import { WebPlugin } from '@capacitor/core';
export class PrinterWeb extends WebPlugin {
    async print() {
        console.log('Not supported web browsers!');
    }
}
//# sourceMappingURL=web.js.map